export default __webpack_public_path__ + "media/images/react_icons/search_white-d6dcbb088936dd49acf198baef1e4907.svg";